// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TimeOutlinedSvg from "@fishx/icons-svg/es/asn/TimeOutlined";
import FishxIcon from '../components/FishxIcon';

var TimeOutlined = function TimeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TimeOutlinedSvg
  }));
};

TimeOutlined.displayName = 'TimeOutlined';
export default React.forwardRef(TimeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TimeOutlined.js
// module id = 4266
// module chunks = 0